import { DATA_COUNTRY } from "../data/options";

const EXTRA_COUNTRY_ZH = {
  "American Samoa": "美屬薩摩亞",
  Anguilla: "安圭拉",
  "Antigua & Barbuda": "安地卡及巴布達",
  Aruba: "阿魯巴",
  Bermuda: "百慕達",
  "Bosnia-Herzegovina": "波士尼亞與赫塞哥維納",
  "Bouvet Island": "布威島",
  "British Indian Ocean Territory": "英屬印度洋領地",
  "British Virgin Islands": "英屬維京群島",
  "Canary Islands": "加那利群島",
  "Christmas Island": "聖誕島",
  "Cocos Islands": "科科斯群島",
  "Cook Islands": "庫克群島",
  "Cote d’Ivoire": "象牙海岸",
  Curacao: "庫拉索",
  "Democratic Republic of the Congo": "剛果民主共和國",
  "East Timor": "東帝汶",
  "Equatorial Guinea": "赤道幾內亞",
  Eritrea: "厄利垂亞",
  "Eswatini (formerly named as Swaziland)": "史瓦帝尼",
  "Falkland Islands": "福克蘭群島",
  "Faroe Islands": "法羅群島",
  Fiji: "斐濟",
  "French Guiana": "法屬圭亞那",
  "French Polynesia": "法屬玻里尼西亞",
  "French Southern Territories": "法屬南部領地",
  Gabon: "加彭",
  Gambia: "甘比亞",
  Gibraltar: "直布羅陀",
  Grenada: "格瑞那達",
  Guadeloupe: "瓜地洛普",
  Guam: "關島",
  "Guernsey C.I.": "根西島",
  Guinea: "幾內亞",
  "Guinea-Bissau": "幾內亞比索",
  Guyana: "蓋亞那",
  Haiti: "海地",
  "Heard & McDonald Islands": "赫德島及麥唐納群島",
  Honduras: "宏都拉斯",
  "Isle of Man": "曼島",
  "Jersey C.I.": "澤西島",
  Kiribati: "吉里巴斯",
  Kosovo: "科索沃",
  "La Reunion": "留尼旺",
  Lesotho: "賴索托",
  Liberia: "賴比瑞亞",
  Madeira: "馬德拉",
  Malawi: "馬拉威",
  Mali: "馬利",
  "Marshall Islands": "馬紹爾群島",
  Martinique: "馬丁尼克",
  Mauritania: "茅利塔尼亞",
  Mauritius: "模里西斯",
  Mayotte: "馬約特",
  Micronesia: "密克羅尼西亞",
  Moldova: "摩爾多瓦",
  Montenegro: "蒙特內哥羅",
  Montserrat: "蒙哲臘",
  Mozambique: "莫三比克",
  Namibia: "納米比亞",
  Nauru: "諾魯",
  "Netherlands Antilles": "荷屬安地列斯",
  "New Caledonia": "新喀里多尼亞",
  Nicaragua: "尼加拉瓜",
  Niger: "尼日",
  Niue: "紐埃",
  "Norfolk Island": "諾福克島",
  "North Korea": "北韓",
  "North Macedonia": "北馬其頓",
  "Northern Mariana Islands": "北馬里亞納群島",
  Palau: "帛琉",
  Palestine: "巴勒斯坦",
  "Papua New Guinea": "巴布亞紐幾內亞",
  Pitcairn: "皮特肯群島",
  "Puerto Rico": "波多黎各",
  "Republic of the Congo": "剛果共和國",
  Rwanda: "盧安達",
  "Saint Barthelemy": "聖巴瑟米",
  "Saint Helena": "聖赫勒拿",
  "Saint Kitts & Nevis": "聖克里斯多福及尼維斯",
  "Saint Lucia": "聖露西亞",
  "Saint Pierre & Micquelon": "聖皮耶與密克隆",
  "Saint Vincent & the Grenadines": "聖文森及格瑞那丁",
  Samoa: "薩摩亞",
  "San Marino": "聖馬利諾",
  "Sao Tome & Principe": "聖多美普林西比",
  "Scalbard & Jan Mayen Islands": "斯瓦爾巴及揚馬延群島",
  Senegal: "塞內加爾",
  Seychelles: "塞席爾",
  "Sierra Leone": "獅子山",
  "Sint Maarten": "聖馬丁",
  "Solomon Islands": "索羅門群島",
  Somalia: "索馬利亞",
  "South Georgia & South Sandwich Islands": "南喬治亞與南桑威奇群島",
  "South Sudan": "南蘇丹",
  "Sudan (including Darfur)": "蘇丹（包括達爾富爾）",
  Suriname: "蘇利南",
  Tanzania: "坦尚尼亞",
  "Territories of Crimea - Sevastopol, Donetsk, Luhansk, Zaporizhzhia and Kherson":
    "克里米亞地區（塞瓦斯托波爾、頓涅茨克、盧甘斯克、札波羅熱及赫爾松）",
  Togo: "多哥",
  "Tokelau Islands": "托克勞群島",
  Tonga: "東加",
  "Trinidad & Tobago": "千里達及托巴哥",
  Turkmenistan: "土庫曼",
  "Turks & Caicos Islands": "特克斯及凱科斯群島",
  Tuvalu: "吐瓦魯",
  Uganda: "烏干達",
  "US Minor Outlying Islands": "美國本土外小島嶼",
  "US Virgin Islands": "美屬維京群島",
  Vanuatu: "萬那杜",
  "Wallis & Futuna Islands": "瓦利斯及富圖納群島",
};

const countryByValue = new Map(
  DATA_COUNTRY.map((item) => [item.value.toLowerCase(), item])
);

export const countryChineseName = (country) => {
  const name = String(country || "").trim();
  if (!name) return "";

  const known = countryByValue.get(name.toLowerCase());
  if (known) {
    return known.label.slice(known.value.length).trim();
  }

  return EXTRA_COUNTRY_ZH[name] || "";
};

export const formatCountryLabel = (country) => {
  const name = String(country || "").trim();
  if (!name) return "";
  const chinese = countryChineseName(name);
  return chinese ? `${name} ${chinese}` : name;
};

export const countrySelectOptions = (extraCountries = []) => {
  const byValue = new Map(
    DATA_COUNTRY.map((item) => [
      item.value,
      { value: item.value, label: item.label },
    ])
  );

  Object.keys(EXTRA_COUNTRY_ZH).forEach((name) => {
    if (!byValue.has(name)) {
      byValue.set(name, { value: name, label: formatCountryLabel(name) });
    }
  });

  extraCountries.forEach((country) => {
    const name = String(country || "").trim();
    if (name && !byValue.has(name)) {
      byValue.set(name, { value: name, label: formatCountryLabel(name) });
    }
  });

  return [...byValue.values()].sort((a, b) => a.value.localeCompare(b.value));
};
